import ProfitsTemplate from '@/features/agent/profits/templates/ProfitsTemplate';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/agent/profits/')({
  component: ProfitsPage,
  staticData: { title: '売上管理' },
});

function ProfitsPage() {
  return <ProfitsTemplate />;
}
